import React, { Fragment, useEffect } from 'react';
import { Helmet } from "react-helmet";
import Footer from '../../components/footer';
import Navbar from '../../components/Navbar';
import Scrollbar from '../../components/scrollbar';
// import Logo from '../../images/Logo/logo-big.png'
import Logo from '../../images/Logo/logo-white-bg.png'
import Request from './form';
// import PageTitle from '../../components/pagetitle/PageTitle';

const RequestForm = () => {
    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    return (
        <Fragment>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Request Form</title>
                <link rel="canonical" href="https://www.deepprabha.com/request" />
                <meta name="description" content="Request a quote or place a bulk chemical order with Deep Prabha Transchem. Get the best prices on solvents, petrochemicals & pharmaceutical products. Fast response guaranteed." />
                <meta name="keywords" content="request chemical quote india, bulk chemical order form, buy chemicals online india, chemical price inquiry, solvent bulk purchase india, chemical procurement request" />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://www.deepprabha.com/request" />
                <meta property="og:title" content="Request a Quote — Deep Prabha Transchem" />
                <meta property="og:description" content="Submit a product or service request and we will address it on priority." />
                <meta property="og:image" content="https://www.deepprabha.com/logo512.png" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Request a Quote — Deep Prabha Transchem" />
                <meta name="twitter:image" content="https://www.deepprabha.com/logo512.png" />
            </Helmet>
            <Navbar topbarBlock={'wpo-header-style-3'} hclass={'wpo-header-style-3'} Logo={Logo} />
            {/* <PageTitle pageTitle={''} pagesub={'Request'} /> */}
            <Request />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default RequestForm;